import { RouteMonitoringData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const ROUTE_MONITORING_DATA_TAG = 'RouteMonitoring';
export default class RouteMonitoringParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.ROUTE_MONITORING, FIXED_PROTOCOL_CONTENT_TYPE_IDS.ROUTE_MONITORING, ROUTE_MONITORING_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            to_wp_crs: 'plannedCourseToWaypoint',
            dist_first_wp: 'distanceSinceFirstWaypoint',
            dest_dist: 'distanceToDestination',
            dist_og: 'totalDistanceTraveledOverGround',
            dist_tw: 'totalDistanceTraveledThroughWater',
            dest_ttg: 'timeToGoToDestination',
            route_plan_changes: 'routeChangeRemarks',
        };
    }
    createData(props) {
        return new RouteMonitoringData(props.plannedCourseToWaypoint, props.distanceSinceFirstWaypoint, props.distanceToDestination, props.totalDistanceTraveledOverGround, props.totalDistanceTraveledThroughWater, props.timeToGoToDestination, props.routeChangeRemarks);
    }
}
//# sourceMappingURL=RouteMonitoringParser.js.map